import { t } from 'i18next';
import styles from './styles.module.scss';
import { SetStateAction } from 'react';

type SearchInput = {
  setFilterCondition: React.Dispatch<SetStateAction<string | undefined>>;
}

function SearchInput(props : SearchInput) : JSX.Element {

  return (
    <div id={styles['biobar-search']}>
      <p>{t('biobar.profile.search.title')}</p>
      <div>
        <span className='material-icons'>search</span>
        <input
          type='text'
          placeholder={t('biobar.profile.search.input') || ''}
          onChange={(event : React.ChangeEvent<HTMLInputElement>) : void => { props.setFilterCondition(event.target.value); }}/>
      </div>
    </div>
  );
}

export default SearchInput;